const MuiTab = {
  root: {
    maxWidth: null,
  },
}

export default MuiTab
